import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-portal-rt_window_close",
  "use": "rt-portal-rt_window_close-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-portal-rt_window_close\">\n<path d=\"M606.3,274.3l338-338c15.6-15.6,15.6-41,0-56.6l0,0c-15.6-15.6-41-15.6-56.6,0l-338,338c-3.1,3.1-8.2,3.1-11.3,0l-338-338\n\tc-15.6-15.6-41-15.6-56.6,0l0,0c-15.6,15.6-15.6,41,0,56.6l338,338c3.1,3.1,3.1,8.2,0,11.3l-338,338c-15.6,15.6-15.6,41,0,56.6l0,0\n\tc15.6,15.6,41,15.6,56.6,0l338-338c3.1-3.1,8.2-3.1,11.3,0l338,338c15.6,15.6,41,15.6,56.6,0l0,0c15.6-15.6,15.6-41,0-56.6l-338-338\n\tC603.1,282.6,603.1,277.5,606.3,274.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/rt_window_close.svg
// module id = 1299
// module chunks = 116